import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, catchError, of, forkJoin, map } from 'rxjs';
import * as modules from '../../../i18n/module-names.json';
import * as coreModules from '../../../i18n/module-shared.json';
import * as layoutsModules from '../../../i18n/module-layouts.json';
@Injectable({
    providedIn: 'root',
})
export class CustomTranslateHttpLoader implements TranslateLoader {
    constructor(private readonly http: HttpClient) {}

    getTranslation(lang: string): Observable<any> {
        const basePaths = ['./i18n/components-translation/', './i18n/shared/', './i18n/layouts/'];
        let dataArr = [...Object.values(JSON.parse(JSON.stringify(modules)).default)];
        let dataArr2 = [...Object.values(JSON.parse(JSON.stringify(coreModules)).default)];
        let dataArr3 = [...Object.values(JSON.parse(JSON.stringify(layoutsModules)).default)];
        const requests = [
            dataArr.map((folder) => this.http.get(`${basePaths[0]}${folder}/${lang}.json`).pipe(catchError(() => of({})))),
            dataArr2.map((folder) => this.http.get(`${basePaths[1]}${folder}/${lang}.json`).pipe(catchError(() => of({})))),
            dataArr3.map((folder) => this.http.get(`${basePaths[2]}${folder}/${lang}.json`).pipe(catchError(() => of({})))),
        ].flat();
        return forkJoin(requests).pipe(
            map((responses) => {
                return responses.reduce((acc, curr) => ({ ...acc, ...curr }), {});
            })
        );
    }
}
